import '@banno/jha-wc/src/forms/jha-form-radio-button/jha-form-radio-button';
import '@jack-henry/jh-ui/components/card/card.js';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmFormControl } from '../forms';

export interface RadioOption {
    value: string;
    label: string;
    caption?: string;
}

export const tagName = 'tm-radio-button';
@customElement(tagName)
export class TmRadioButton extends TmFormControl<string> {
    @property({ type: Array })
    public options: RadioOption[] = [];

    @property({ type: String })
    public label: string = '';

    @property({ type: Boolean })
    public disabled = false;

    protected render() {
        if (!this.name) {
            throw new Error('Name is required to render the radio button');
        }

        if (this.label) {
            return html` <label>
                <div class="mb-3">${this.label}</div>
                ${this.renderRadioOptions()}
            </label>`;
        }
        return this.renderRadioOptions();
    }

    protected renderRadioOptions() {
        return this.options.map((option: RadioOption, index: number) =>
            this.renderRadioButton(option, index)
        );
    }

    protected validate(): boolean {
        return true;
    }

    private async handleClick(e: CustomEvent, value: string) {
        if (this.disabled) {
            return;
        }
        await this.changeValue(value ?? '');
        this.dispatchEvent(
            new CustomEvent('change', {
                detail: {
                    value,
                },
            })
        );
    }

    private renderRadioButton(option: RadioOption, index: number) {
        const id = `${this.name}-${index}`;
        return html`
            <jha-form-radio-button
                ?disabled=${this.disabled}
                ?checked=${this.value === option.value}
                @click=${(e: CustomEvent) => this.handleClick(e, option.value)}
                name=${this.name}
                value=${option.value}
                for=${id}
                id=${id}
            >
                <div class="option-label">${option.label}</div>
                ${option.caption
                    ? html`<p class="text-xs text-ftr-gray-500">${option.caption}</p>`
                    : ''}
            </jha-form-radio-button>
            <slot name=${`sub-content-${option.value}`}></slot>
        `;
    }

    public static get styles() {
        return css`
            :host {
                --radio-label-font-weight: var(400);

                .option-label {
                    font-weight: var(--radio-label-font-weight, 400);
                }
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmRadioButton;
    }
}
